import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=5a30267c&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=5a30267c&prod&lang=css&"
import style1 from "./Sidebar.scss?vue&type=style&index=1&id=5a30267c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30267c",
  null
  
)

export default component.exports